export default __webpack_public_path__ + "36c0efe288ba0ee0f90ca8b4561a44b5.jpg";